import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'
import en from 'dayjs/locale/en'

dayjs.extend(utc)
dayjs.extend(timezone)

/**
 * @param {string[]} pointIdList
 * @param {object} data
 * @param {number} now
 * @param {string} timezone
 *
 *
 */
export const formatAirportWeather = (pointIdList, data, now) => {
  if (pointIdList.length === 0) {
    return {}
  }

  const timezone = data[pointIdList[0]].timezone

  const dailyData = {}
  pointIdList.forEach((pointId) => {
    const pointData = data[pointId]
    const mrf = pointData.mrf
    dailyData[pointId] = formatDaily(mrf, now, data[pointId].timezone)
  })

  const weekList = dailyData[pointIdList[0]].map((item) => {
    return {
      date: item.date,
      dowEn: item.dowEn,
      dowJa: item.dowJa
    }
  })

  return {
    dailyData,
    weekList,
    timezone
  }
}

/**
 *
 * @param {Object[]} mrf
 * @param {number} now
 * @param {string} timezone
 * @returns {Object[]}
 */
const formatDaily = (mrf, now, timezone) => {
  const nowInTz = dayjs.unix(now).tz(timezone)
  return mrf
    .map((item) => {
      const tm = dayjs.unix(item.utm).tz(timezone)
      const isHourlyTz = tm.minute() === 0
      const modifiedTm = isHourlyTz ? tm : tm.startOf('hour').add(1, 'hour')
      const isPast = modifiedTm.startOf('day').unix() < nowInTz.startOf('day').unix()
      return {
        ...item,
        past: isPast,
        date: modifiedTm.format('D'),
        dowEn: modifiedTm.locale(en).format('ddd').toLowerCase(),
        dowJa: modifiedTm.locale(ja).format('ddd')
      }
    })
    .filter((item) => !item.past)
    .filter((_, index) => index < 10)
}
